// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon;

module.exports.RiCheckboxCircleLine = function RiCheckboxCircleLine(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "g",
      "attr": {},
      "child": [{
        "tag": "path",
        "attr": {
          "fill": "none",
          "d": "M0 0h24v24H0z"
        }
      }, {
        "tag": "path",
        "attr": {
          "d": "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-.997-4L6.76 11.757l1.414-1.414 2.829 2.829 5.656-5.657 1.415 1.414L11.003 16z"
        }
      }]
    }]
  })(props);
};